// eslint-disable-next-line
import React, { CSSProperties } from 'react';

import './logsearch.css'

import Container from '../../basicComponents/Container';
import Text from '../../basicComponents/Text';
import { AppContext } from '../../AppContext';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import InputDate from '../../basicComponents/InputDate';
import ListSelect from '../../appComponents/ListSelect';
import InputTime from '../../basicComponents/InputTime';
import { LogSearchParameter, LogSearchSearchRequest, LogSearchSearchResponse } from '../../data/interface';
import { Logging } from '../../data/Logging';
import Button from '../../basicComponents/Button';
import Select from '../../basicComponents/Select';
import { deepCopy } from '../../util/DeepCopy';
import TextClick from '../../basicComponents/TextClick';
import LogRecord from '../../data/LogRecord';

export interface LogSearchPageProps extends RouteComponentProps {

    logSearchParameter: LogSearchParameter;
    logList: Logging[];

    setLogSearchParameter: (logSearchParameter: LogSearchParameter) => void;
    setLogList: (logList: Logging[]) => void;
    setCurRecord: (curRecord: LogRecord | undefined) => void;

    searchRange: string;
    searchLimit: number;

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LogSearchPageState { }

class LogSearchPageComponent extends React.Component<LogSearchPageProps, LogSearchPageState> {

    // app context
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>;

    // log level
    logLevel: string[] = [ 'FINE', 'INFO', 'INTERFACE', 'WARNING', 'SEVERE' ]

    constructor(props: LogSearchPageProps) {

        // call parent
        super(props);

        // set state
        this.state = {
            logList: [],
        };

    }

    public render = (): JSX.Element => {

        return (
            <React.Fragment>
                
                <Container className='logsearch-parameter'>

                    <Container className='logsearch-listSelect'>
                        <ListSelect allEntries={this.props.logSearchParameter.serverEntries} selectedEntries={this.props.logSearchParameter.selectedServer} handleSelectChange={this.handleSelectChange} />
                    </Container>

                    <Container className='logsearch-block-date'>
                        <Text className='logsearch-label'>Date From</Text>
                        <InputDate className='logsearch-date-time' name='DateFrom' value={this.props.logSearchParameter.queryDateFrom} onChange={this.handleChange} />
                        <InputTime className='logsearch-date-time' name='TimeFrom' value={this.props.logSearchParameter.queryTimeFrom} onChange={this.handleChange} />
                        <Text className='logsearch-label'>Date To</Text>
                        <InputDate className='logsearch-date-time' name='DateTo' value={this.props.logSearchParameter.queryDateTo} onChange={this.handleChange} />
                        <InputTime className='logsearch-date-time' name='TimeTo' value={this.props.logSearchParameter.queryTimeTo} onChange={this.handleChange} />
                        <div /><div /><div />
                        <Text className='logsearch-label'>LogLevel</Text>
                        <Select className='logsearch-logLevel' name='logLevel' value={this.getLogLevelText(this.props.logSearchParameter.logLevel)} options={this.logLevel} onChange={this.handleLogLevelChange}/>
                        <div />
                    </Container>

                    <Container className='logsearch-block-button'>
                        <Button className='logsearch-button' name='search' value='search' onClick={this.handleClick} />
                        {this.props.logList !== undefined ? <Text className='logsearch-count-records'>{this.props.logList.length + ' message' + (this.props.logList.length !== 1 ? 's' : '')}</Text> : null}
                    </Container>

                </Container>

                <Container className='logsearch-divider' />

                <Container className='logsearch-list'>
                    {this.props.logList
                        .map( (entry, idx) => {

                            entry.logDate = entry.logDate.replace('T', ' ');

                            let levelClass = 'logsearch-levelFine';
                            if (entry.level >= 1000) { levelClass = 'logsearch-levelSevere'; }
                            else if (entry.level >= 900) { levelClass = 'logsearch-levelWarning'; }
                            else if (entry.level >= 850) { levelClass = 'logsearch-levelIFace'; }
                            else if (entry.level >= 800) { levelClass = 'logsearch-levelInfo'; }

                            let validSession = true;
                            if (entry.sessionId === 'TMP_000000000' || entry.sessionId.endsWith('000000000')) {
                                validSession = false;
                            }

                            return (
                                <React.Fragment key={idx}>
                                    <Text className={levelClass}></Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.logDate}</Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.logTime}</Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.thread}</Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.level}</Text>
                                    {validSession ? 
                                        <TextClick className={idx % 2 === 0 ? ' logsearch-click-even' : ' logsearch-click-odd'} name={entry.sessionId} onClick={this.handleSessionClick}>{entry.sessionId}</TextClick>
                                        :
                                        <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.sessionId}</Text>
                                    }
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.className}</Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.method}</Text>
                                    <Text className={idx % 2 === 0 ? ' logsearch-value-even' : ' logsearch-value-odd'}>{entry.message}</Text>
                                </React.Fragment> 
                            );

                    })}
                </Container>

            </React.Fragment>
        );

    }

    public componentDidMount = (): void => {

        // check selected entries
        const setting = this.context.user.getUserSetting('SymQuery', 'searchHosts');
        if (setting != null) {
            const searchHosts = JSON.parse(setting) as string[];
            const logSearchParameter = { ...this.props.logSearchParameter };
            logSearchParameter.selectedServer = searchHosts;
            this.props.setLogSearchParameter(logSearchParameter);
        }

    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;
        const value = target.value;

        // check static fields
        switch (name) {

            // check static fields
            case 'DateFrom':  { const searchParameter = { ...this.props.logSearchParameter }; searchParameter.queryDateFrom = value; this.props.setLogSearchParameter(searchParameter); } break;
            case 'DateTo':    { const searchParameter = { ...this.props.logSearchParameter }; searchParameter.queryDateTo   = value; this.props.setLogSearchParameter(searchParameter); } break;
            case 'TimeFrom':  { const searchParameter = { ...this.props.logSearchParameter }; searchParameter.queryTimeFrom = value; this.props.setLogSearchParameter(searchParameter); } break;
            case 'TimeTo':    { const searchParameter = { ...this.props.logSearchParameter }; searchParameter.queryTimeTo   = value; this.props.setLogSearchParameter(searchParameter); } break;

        }

    }

    private handleLogLevelChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;
        const value = target.value;

        switch (name) {
            case 'logLevel':
                {
                    const logSearchParameter = deepCopy(this.props.logSearchParameter);
                    logSearchParameter.logLevel = this.getLogLevelNumber(value);
                    this.props.setLogSearchParameter(logSearchParameter);
                }
                break;
        }

    }

    private handleSelectChange = (selectedEntries: string[]): void => {
        this.context.user.setUserSetting('SymQuery', 'searchHosts', JSON.stringify(selectedEntries));
        const searchParameter = { ...this.props.logSearchParameter };
        searchParameter.selectedServer = selectedEntries;
        this.props.setLogSearchParameter(searchParameter);
    }

    private handleClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        if (name === 'search') {
            this.postLogSearchSearch()
                .then(
                    (result): void => {
                        this.props.setLogList(result.logList);
                    }
                )
                .catch(
                    (message): void => {
                        this.props.setLogList([]);
                        this.context.app.setMessageText(message);
                    }
                )
        }

    }

    private handleSessionClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        this.props.setCurRecord(undefined);
        this.context.app.addSidebar({ name: 'LOG ' + name, link: '/logging/' + name });
        this.props.history.push('/logging/' + name);

    }

    private postLogSearchSearch = (): Promise<LogSearchSearchResponse> => {

        return new Promise<LogSearchSearchResponse> (

            (resolve, reject): void => {

                // build request
                const request: LogSearchSearchRequest = {
                    logSearchParameter: this.props.logSearchParameter,
                    limit: this.props.searchLimit,
                }

                // send request
                this.context.app.showLoader(true);
                this.context.restAppService.request_post('logSearch/search', this.context.user.getToken(), 'text/json', JSON.stringify(request),
                    (data): void => {
                        this.context.app.showLoader(false);
                        const response = JSON.parse(data) as LogSearchSearchResponse;
                        resolve(response);
                    },
                    (status, text): void => {
                        this.context.app.showLoader(false);
                        reject('failure ' + status + '/' + text);
                    }
                )

            }

        );

    }

    private getLogLevelText = (logLevel: number): string => {
        switch (logLevel) {
            case  500: return 'FINE'; 
            case  800: return 'INFO'; 
            case  850: return 'INTERFACE'; 
            case  900: return 'WARNING'; 
            case 1000: return 'SEVERE'; 
        }
        return 'WARNING';
    }

    private getLogLevelNumber = (logLevel: string): number => {
        switch (logLevel) {
            case 'FINE': return 500;
            case 'INFO': return 800;
            case 'INTERFACE': return 850;
            case 'WARNING': return 900;
            case 'SEVERE': return 1000;
        }
        return 900;
    }

}

const LogSearchPage = withRouter(LogSearchPageComponent);
export default LogSearchPage;
